import { call, put, takeLatest } from 'redux-saga/effects';
import { ApiResponse } from '../../api/request';
import {
  deleteReservationAPI, getTBLinkAPI, reservationsListAPI
} from '../../api/provider/booking/booking-provider';
import {
  deleteReservationAction,
  getReservationListAction,
  getReservationListErrorAction,
  getReservationListSuccessAction,
  getReservationUpdateDeleteAction, getTBLinkAction,
  tbLinkErrorAction,
  tbLinkSuccessAction
} from '../../store/shared/reservations-list.store';
import { productListAPI, smartObjectAPI } from '../../api/provider/product/product-provider';
import { authenticatedCall } from '../../utils/authenticated-call';

function* reservationsListSaga(data: any) {

  try {
    const reservationsListResponse: ApiResponse = yield authenticatedCall(reservationsListAPI, data.payload);
    const roomsListResponse: ApiResponse = yield call(productListAPI)
    const smartObjectResponse: ApiResponse  = yield authenticatedCall(smartObjectAPI);

    const response = {
      reservations: reservationsListResponse.data.data,
      rooms: roomsListResponse.data.data,
      smartObjects: smartObjectResponse.data.data
    }

    yield put(getReservationListSuccessAction(response));

  } catch (error: any) {
    yield put(getReservationListErrorAction(error.localizedMessage))
    return
  }

}

function* deleteReservationSaga(data: any) {

  try {
    yield call(deleteReservationAPI, data.payload);
    yield put(getReservationUpdateDeleteAction())

  } catch (error: any) {
    yield put(getReservationListErrorAction(error.localizedMessage))
    return
  }
}

function* getTBLinkSaga(data: any) {

  try {
    const tbLinkResponse : ApiResponse = yield authenticatedCall(getTBLinkAPI, data.payload);
    yield put(tbLinkSuccessAction(tbLinkResponse.data.data))

  } catch (error: any) {
    yield put(tbLinkErrorAction(error.localizedMessage))
    return
  }
}

export function* reservationsListSagas() {
  yield takeLatest(getReservationListAction.type, reservationsListSaga);
  yield takeLatest(deleteReservationAction.type, deleteReservationSaga);
  yield takeLatest(getTBLinkAction.type, getTBLinkSaga);
}
